export const columns = [
  {
    name: 'cusip',
    title: 'cusip #',
    width: 102,
  },
  {
    name: 'name',
    title: 'bond',
    width: 319,
    maxWidth: 319,
  },
  {
    name: '',
    sortable: false,
    minWidth: 53,
  },
];
